import type { FilterFn } from "@tanstack/react-table";
import type { DateRangeValue } from "@/components/ui/DateRangeInput";

function isDateRangeEmpty(value: unknown): boolean {
  const range = value as DateRangeValue | undefined;
  return !range || (range.from === undefined && range.to === undefined);
}

// Mirrors createNumberRangeFilterFn: the actual filtering happens server-side
// (manualFiltering), so the row check is a no-op. autoRemove is what keeps an
// active `{from, to}` filter value from being dropped from columnFilters state.
export function createDateRangeFilterFn<TData>(): FilterFn<TData> {
  const filterFn: FilterFn<TData> = () => true;
  filterFn.autoRemove = isDateRangeEmpty;
  return filterFn;
}
